import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class DgTitleStrategyService extends TitleStrategy {
  constructor(private titleService: Title) {
    super();
  }

  updateTitle(snapshot: RouterStateSnapshot): void {
    const title = this.buildTitle(snapshot);
    this.setTitle(title);
  }

  setTitle(title: string) {
    this.titleService.setTitle(`${title ? title + ' | ' : ''}DigiGOV`);
  }
}
